import { BlogSection } from '@/types/blog';

export const positionierung: BlogSection = {
  id: 'positionierung',
  title: 'Die Positionierung: Expertise durch Synthese',
  content: `
<p class="mb-4 text-lg font-medium">
  "Aber wie soll ich mich positionieren, wenn ich kein Nischen-Experte bin?"
</p>

<p class="mb-4">
  Anders. Nicht über ein "Was", sondern über ein "Wie" oder "Warum":
</p>

<div class="space-y-4 my-6">
  <div class="bg-joerg-50 p-4 rounded-lg border-l-4 border-joerg-300">
    <p class="line-through text-joerg-500">Statt: "Ich bin Experte für Change Management"</p>
    <p class="text-primary font-medium mt-2">Lieber: "Ich helfe Organisationen, Change nicht zu managen, sondern zu kultivieren – als lebendigen Prozess"</p>
  </div>
  
  <div class="bg-joerg-50 p-4 rounded-lg border-l-4 border-joerg-300">
    <p class="line-through text-joerg-500">Statt: "Ich bin HR-Spezialist"</p>
    <p class="text-primary font-medium mt-2">Lieber: "Ich schaffe Führungssysteme, die menschliche Vielfalt als Stärke nutzen"</p>
  </div>
</div>

<div class="bg-primary/10 p-6 rounded-xl border-l-4 border-primary mb-8 mt-6">
  <p class="text-lg font-medium">
    Ihre Expertise liegt in der Synthese. Im Brückenbau zwischen Welten. Im Übersetzen zwischen Sprachen. Das ist nicht weniger wert als Detail-Wissen – es ist seltener. Und für komplexe Systeme oft wertvoller.
  </p>
</div>
  `,
};
